import { createMutateReducer } from "common/helpers/reducer";
import * as action from "../actions/transactionListAction";

const initialState = {
	isLoading: true,
	isNoItems: false,

	scroll: {
		isLoading: false,
		size: 20,
		page: 0,
		totalElements: 0
	},
	search: {
		isLoading: false,
		value: ""
	},
	filter: {
		isLoading: false,
		by: "",
		start: "",
		end: ""
	},
	sort: {
		field: "transactionCreated",
		order: "desc"
	},
	itemsActions: {},

	kkmId: "",
	company: {},
	kkm: {},
	items: []
};
const actionHandlers = {
	// Initialize
	[action.initKkmTransactionList.request]: createMutateReducer((draft, { kkmId }) => {
		draft.isLoading = true;
		draft.isNoItems = false;

		draft.scroll.isLoading = false;
		draft.scroll.page = 0;
		draft.scroll.totalElements = 0;

		draft.search.isLoading = false;
		draft.search.value = "";

		draft.itemsActions = {};

		draft.filter.isLoading = false;

		draft.kkmId = kkmId;
		draft.company = {};
		draft.items = [];
	}),
	[action.initKkmTransactionList.success]: createMutateReducer((draft, { company, items, kkm, totalElements }) => {
		draft.isLoading = false;
		draft.isNoItems = !items.length;

		draft.scroll.totalElements = totalElements;

		draft.company = company;
		draft.kkm = kkm;
		draft.items = items;
	}),
	[action.initKkmTransactionList.error]: createMutateReducer(draft => {
		draft.isLoading = false;
		draft.isNoItems = true;
	}),

	// Scroll
	[action.scrollKkmTransactionList.request]: createMutateReducer(draft => {
		draft.scroll.isLoading = true;
	}),
	[action.scrollKkmTransactionList.success]: (state, { items, page }) => ({
		...state,
		scroll: {
			...state.scroll,
			isLoading: false,
			page
		},
		items: [...state.items, ...items]
	}),
	[action.scrollKkmTransactionList.error]: createMutateReducer(draft => {
		draft.scroll.isLoading = false;
	}),

	// Search
	[action.searchKkmTransactionList.request]: createMutateReducer((draft, { value }) => {
		draft.search.isLoading = true;
		draft.search.value = value;
	}),
	[action.searchKkmTransactionList.success]: createMutateReducer((draft, { items, totalElements }) => {
		draft.scroll.page = 0;
		draft.scroll.totalElements = totalElements;

		draft.search.isLoading = false;

		draft.items = items;
	}),
	[action.searchKkmTransactionList.error]: createMutateReducer(draft => {
		draft.search.isLoading = false;
	}),

	// Filter
	[action.filterKkmTransactionList.request]: createMutateReducer((draft, params, state) => {
		draft.filter = {
			isLoading: true,
			...state.filter,
			...params
		};
	}),
	[action.filterKkmTransactionList.success]: createMutateReducer((draft, { items, totalElements }) => {
		draft.scroll.page = 0;
		draft.scroll.totalElements = totalElements;

		draft.filter.isLoading = false;

		draft.items = items;
	}),
	[action.filterKkmTransactionList.error]: createMutateReducer(draft => {
		draft.filter.isLoading = false;
	}),

	// Sort
	[action.sortKkmTransactionList.request]: createMutateReducer((draft, { field, order }) => {
		draft.filter.isLoading = true;
		draft.sort = { field, order };
	}),
	[action.sortKkmTransactionList.success]: createMutateReducer((draft, { items, totalElements }) => {
		draft.scroll.page = 0;
		draft.scroll.totalElements = totalElements;

		draft.filter.isLoading = false;

		draft.items = items;
	}),
	[action.sortKkmTransactionList.error]: createMutateReducer(draft => {
		draft.filter.isLoading = false;
	}),

	// Show detail transaction
	[action.showDetailKkmTransactionList]: createMutateReducer((draft, { requestId }, state) => {
		draft.itemsActions[requestId] = state.itemsActions[requestId] || {};
		draft.itemsActions[requestId].isOpen = !draft.itemsActions[requestId].isOpen;
	})
};

export { initialState, actionHandlers };
export default createReducer => createReducer(initialState, actionHandlers);
